import API_ENDPOINTS from "@/common/api/apiEndpoints";
import httpClient from "@/common/api/httpClient";
import httpMethods from "@/common/api/httpMethods";
import type {
  Configuration,
  CreateConfigurationPayload,
  UpdateConfigurationPayload,
} from "@/common/types/Cycle";

export const fetchConfigurations = (
  workspaceVersionId: number,
  type?: string,
) =>
  httpClient<{ data: Configuration[] }>(
    httpMethods.GET,
    `${API_ENDPOINTS.CYCLES.configurations}?workspaceVersionId=${workspaceVersionId}${type ? `&type=${type}` : ""}`,
  ).then((res) => res.data.data ?? []);

export const createConfiguration = (
  payload: CreateConfigurationPayload & { workspace_version_id: number },
) =>
  httpClient<{ data: Configuration }>(
    httpMethods.POST,
    API_ENDPOINTS.CYCLES.configurations,
    payload,
  ).then((res) => res.data.data);

export const updateConfiguration = (
  configId: number,
  payload: UpdateConfigurationPayload,
) =>
  httpClient<{ data: Configuration }>(
    httpMethods.PUT,
    `${API_ENDPOINTS.CYCLES.configurations}/${configId}`,
    payload,
  ).then((res) => res.data.data);

export const deleteConfiguration = (configId: number) =>
  httpClient<void>(
    httpMethods.DELETE,
    `${API_ENDPOINTS.CYCLES.configurations}/${configId}`,
  );
